module.exports = __webpack_public_path__ + "0835fcd83b9d19e221438f7fc3908fad.svg";


//////////////////
// WEBPACK FOOTER
// ./components/icon/svg/pencil.svg
// module id = AefZ
// module chunks = 0